export var SavedQuerySortField;
(function (SavedQuerySortField) {
    SavedQuerySortField["SAVED_QUERY_SORT_FIELD_CREATED_AT"] = "createdAt";
    SavedQuerySortField["SAVED_QUERY_SORT_FIELD_UPDATED_AT"] = "updatedAt";
    SavedQuerySortField["SAVED_QUERY_SORT_FIELD_NAME"] = "name";
})(SavedQuerySortField || (SavedQuerySortField = {}));
